export default __webpack_public_path__ + "static/media/icon_partner-gold.79518fda.svg";